
export const CapabilityName = {   
    BackSplash : 'backsplash',
    Loader : 'loader',
    Modal: 'modal',
    Notification: 'notification',
    ReleaseNotes: 'releasenotes',
}
